import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Container,
  CircularProgress,
} from "@mui/material";
import { useSnackbarAlert } from "../../hooks/useSnackbarAlert";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../../firebase"; // centralized auth import

const ForgotPasswordPage = () => {
  const snackbar = useSnackbarAlert();

  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      snackbar.error("Please enter your email.");
      return;
    }

    setLoading(true);
    try {
      await sendPasswordResetEmail(auth, email);
      snackbar.success("Password reset email sent. Please check your inbox.");
    } catch (err) {
      console.error(err);
      snackbar.error("Failed to send reset email. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ py: 10 }}>
      <Box textAlign="center" mb={4}>
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Reset Your Password
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Enter your email address below and we’ll send you a link to reset your
          password.
        </Typography>
      </Box>

      <Box component="form" onSubmit={handleSubmit}>
        <TextField
          label="Email"
          type="email"
          fullWidth
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          sx={{ mb: 3 }}
        />

        <Button type="submit" variant="contained" fullWidth disabled={loading}>
          {loading ? (
            <>
              <CircularProgress size={20} sx={{ mr: 1 }} />
              Sending...
            </>
          ) : (
            "Send Reset Link"
          )}
        </Button>

        <Box sx={{ mt: 3, textAlign: "center" }}>
          <Typography variant="body2">
            Remembered your password?{" "}
            <a
              href="/login"
              style={{ color: "#FD7762", textDecoration: "none" }}>
              Log in
            </a>
          </Typography>
        </Box>
      </Box>
    </Container>
  );
};

export default ForgotPasswordPage;
